/* eslint-disable */
import { Box, Card, Divider, Group, Title } from "@mantine/core";
import React, { useState } from "react";
import { YearlyStatusChart } from "./components/employeeyearlyStatus/employeeYearlyStatus";
// import { TimeUtilCard } from "./components/progress";
import { Statistics } from "./components/statictics/statistics";
import { RecentActivity } from "./components/recentActivity/recentActivity";
import {
  MonthlyDatum,
  MonthlyStatisticsResponse,
  useGetYearlyStatistics,
} from "api/attendance/employeeYearlyStatus";
import AttendanceEmployeeTable from "./components/table/attendanceTableEmployee";
import PunchOutModal from "./components/punchOutModal";
import { TimeUtilCard } from "./components/progress/progress";
import EmployeeAttendanceTable from "features/attendance-employee/components/EmployeeAttendanceTable";

interface AttendanceEmployeesProps {
  userId?: string | null;
}

export default function AttendanceEmployees({ userId }: AttendanceEmployeesProps) {
  const {
    data: response,
    isLoading,
    isError,
  } = useGetYearlyStatistics(userId || undefined) as {
    data?: MonthlyStatisticsResponse;
    isLoading: boolean;
    isError: boolean;
  };
  const monthlyData: MonthlyDatum[] = response?.data?.monthlyData ?? [];

  const months: string[] = monthlyData.map((item: MonthlyDatum) =>
    new Date(item.year, item.month - 1).toLocaleString("default", {
      month: "short",
    }),
  );
  const workingHours: number[] = monthlyData.map(
    (item: MonthlyDatum) => item.workingHours,
  );
  const progress: number[] = monthlyData.map(
    (item: MonthlyDatum) => item.employeeProgress,
  );

  return (
    <Box>
      {/* <Group position="apart" mb="md">
       <Title order={2}>Attendance Employees</Title>
      </Group>
      <Divider mb="md" />
     */}
      <div style={{ display: "flex", gap: "15px" }}>
        <TimeUtilCard userId={userId} />
        <YearlyStatusChart
          years={months}
          workingHours={workingHours}
          progress={progress}
        />
      </div>
      <div style={{ marginTop: "20px", display: "flex", gap: 15 }}>
        <Statistics userId={userId} />
        <RecentActivity userId={userId} />
      </div>
      <div style={{ marginTop: "15px" }}>
        {/* <AttendanceEmployeeTable /> */}
        <EmployeeAttendanceTable userId={userId} />
      </div>
    </Box>
  );
}
